import { Component, Input, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Footer, StrapiLink } from '../interfaces/cpe-interfaces.index';
import { ImagesUtil } from '@cpe/app/utils/image.util';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule],
  providers: [ImagesUtil],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() footerData!: Footer;

  externalIcon = 'open_in_new';
  readonly imageUtils = inject(ImagesUtil);

  getImageUrl(path: string): string {
    return this.imageUtils.getImageUrl(path);
  }

  getValidLinks(links: StrapiLink[]): StrapiLink[] {
    return links?.filter((link) => link?.url && link?.name) ?? [];
  }
}
